/**
 * 3.1.3.1 블랙 리스트 등록 (프로파일 Tab) Store
 *
 * @since 2021-10-04
 * @author wj_tams_dev02
 */

import resultFactory from '~/utils/resultFactory'

export const state = () => ({
  blockListProfileUrl: '/api/cm/blist/prf',
  blackListRegUrl: '/api/cm/blist',
  getBlackListProfileData: [],
  profilePopupData: [],
  profileRowSelectItems: []
})

export const mutations = {
  clearStore: (state) => {
    state.getBlackListProfileData = []
    state.profilePopupData = []
    state.profileRowSelectItems = [] // 프로파일 선택
  },
  syncTable: (state, payload) => {
    state.profilePopupData = _.cloneDeep(payload)
  },
  setProfileRowSelectItems: (state, data) => {
    state.profileRowSelectItems = _.cloneDeep(data)
  },
  profileHeaderMutation: (state, data) => {
    state.getBlackListProfileData = _.map(state.getBlackListProfileData, (item) => {
      item.blist_prf_use_yn = data
      return item
    })
  },
  // 블랙 리스트 프로파일 조회
  getBlackListProfileDataAction: (state, data) => {
    state.getBlackListProfileData = _.cloneDeep(data)
  },
  // 블랙 리스트 프로파일 추가
  addBlackListProfileDataAction: (state, data) => {
    const resultData = {
      blist_prf_id: data.blist_prf_id,
      blist_prf_use_yn: state.profilePopupData.blist_prf_use_yn,
      blist_prf_name: state.profilePopupData.blist_prf_name,
      blist_prf_desc: state.profilePopupData.blist_prf_desc,
      blist_device_id_list_str: state.profilePopupData.blist_device_id_list_str,
      blist_device_id_list: state.profilePopupData.blist_device_id_list,
      blist_prf_type: state.profilePopupData.blist_prf_type
    }
    state.getBlackListProfileData.push(resultData)
  },
  // 블랙 리스트 프로파일 편집
  editBlackListProfileDataAction: (state) => {
    const resultData = {
      blist_prf_id: state.profilePopupData.blist_prf_id,
      blist_prf_use_yn: state.profilePopupData.blist_prf_use_yn,
      blist_prf_name: state.profilePopupData.blist_prf_name,
      blist_prf_desc: state.profilePopupData.blist_prf_desc,
      blist_device_id_list_str: state.profilePopupData.blist_device_id_list_str,
      blist_device_id_list: state.profilePopupData.blist_device_id_list,
      blist_prf_type: state.profilePopupData.blist_prf_type
    }
    state.getBlackListProfileData = _.map(state.getBlackListProfileData, (item) => {
      if (item.blist_prf_id === resultData.blist_prf_id) {
        item = _.cloneDeep(resultData)
      }
      return item
    })
  }
}

export const actions = {
  // 블랙 리스트 프로파일 목록 조회
  async getBlackListProfileDataAction ({commit, state}) {
    try {
      const data = await this.$axios.$get(state.blockListProfileUrl)
      return resultFactory(commit, {length: null, data: data, action: 'getBlackListProfileDataAction', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 블랙 리스트 프로파일 추가
  async addBlackListProfileDataAction ({commit, state}, payload) {
    try {
      const data = await this.$axios.$post(state.blockListProfileUrl, payload)
      return resultFactory(commit, {length: null, data: data, action: 'addBlackListProfileDataAction', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 블랙 리스트 프로파일 수정
  async editBlackListProfileDataAction ({commit, state}, payload) {
    try {
      const data = await this.$axios.$put(`${state.blockListProfileUrl}/${state.profileRowSelectItems[0].blist_prf_id}`, payload)
      return resultFactory(commit, {
        length: null,
        data: data,
        action: 'editBlackListProfileDataAction',
        param: null
      })
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 블랙 리스트 프로파일 삭제 // 멀티 삭제 지원안함.
  async delBlackListProfileDataAction  ({commit, state}) {
    let isMulty = false
    const idList = []
    if (state.profileRowSelectItems.length > 1) {
      isMulty = true
      state.profileRowSelectItems.forEach((item) => {
        idList.push({'blist_prf_id': item.blist_prf_id})
      })
    }
    try {
      const data = isMulty ? await this.$axios.$delete(state.blockListProfileUrl, {data: {items: idList}}, {failAlert: false}) : await this.$axios.$delete(`${state.blockListProfileUrl}/${state.profileRowSelectItems[0].blist_prf_id}`)
      return resultFactory(commit, {length: idList.length, data: data, action: null, param: 'delete'})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 블랙 리스트 프로파일 일괄수정 // 일괄수정 없음.
  async editBlackListProfileListDataAction ({commit, state, dispatch}, payload) {
    try {
      const data = await this.$axios.$put(state.blockListProfileUrl, {items: payload}, {failAlert: false})
      return resultFactory(commit, {length: payload.length, data: data, action: null, param: 'edit'})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // 블랙 리스트 적용/취소
  async commitAndRollBackPage ({commit, state}, type) {
    try {
      let msg = {}
      if (type === 'apply') {
        msg = {applyMsg: true}
      } else if (type === 'cancel') {
        msg = {cancelMsg: true}
      }
      const data = await this.$axios.$put(`${state.blackListRegUrl}/${type}`, null, msg)
      if (data.code !== 'ok') {
        return false
      }
      this.dispatch(`common/common/setIsChanged`, false)
      return 'ok'
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  }
}
export const strict = false
